import { useState } from 'react';
import './App.css';
import CreateArea from './components/CreateArea';
import Header from './components/Header';
import Note from './components/Note';

function App() {

  const [notes, setNotes] = useState([]);
  // console.log(...notes);                      //{},{},{},{},{}

  const addNote = (newNote) => {
    setNotes([...notes, newNote])
  }

  const deleteNotes = (id, note) => {
    // console.log(note);
    setNotes([...notes.filter((elem, index) => (
      index !== id
    ))
    ])
  }


  return (
    <div className="App">
      <Header />
      <CreateArea onAdd={addNote} />
      {notes.map((note, index) => (
        <Note
          note={note}
          key={index}
          id={index}
          title={note.title}
          content={note.content}
          onDelete={deleteNotes}
        />
      ))}
    </div>
  );
}

export default App;
